export default __webpack_public_path__ + "locales/ja-JP/EmbeddingPanel.json?hash=57421691a71c0e76c1fcfe835e770b2b";